import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle, faCheckCircle, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';

import {roundedElements} from 'Services/BaseHelpers';
import {translation} from 'Services/TranslationHelpers';
import { asset } from "../../Services/BaseHelpers";

export default class PageHeader extends React.Component {
    /**
     * @constructor
     */
    constructor() {
        super();
    }

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const {title, subtitle, imgSrc = 'BMW-Homepage-Hero.png', additionalClasses} = this.props;

        return (
            <div
                className={`relative ${additionalClasses}`}
            >
                <img src={ asset(`images/${ imgSrc }?v=2`) }/>
                <div className="absolute text-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 uppercase ">
                    <h1 className="text-lg lg:text-3xl xl:text-5xl text-center tracking-widest bmw-condenced-el">
                        {title}
                    </h1>
                    <h1 className="text-sm lg:text-lg xl:text-2xl text-center mt-4 tracking-widest bmw-condenced-sb">
                        {subtitle}
                    </h1>
                </div>
            </div>
        )
    };
}


